import LoginError from './LoginError';
class InvalidUserConnection extends LoginError {
    constructor(options) {
        super('User connection not allowed', options);
    }
}
export default InvalidUserConnection;
